import type { Identifier } from "ra-core";
import { useGetIdentity, useTranslate } from "ra-core";

import { CompanyInputs } from "@/components/atomic-crm/companies/CompanyInputs";
import { CreateSheet } from "@/components/atomic-crm/misc/CreateSheet";
import { EditSheet } from "@/components/atomic-crm/misc/EditSheet";
import { withWebsiteProtocol } from "./companyValues";

/**
 * New organization from the phone (task 1.12, D-044): the desktop inputs,
 * "Dati Tenax" included, in a full-height sheet; saved at once (D-033).
 */
export const CompanyCreateSheet = ({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) => {
  const { identity } = useGetIdentity();
  const translate = useTranslate();
  return (
    <CreateSheet
      resource="companies"
      title={translate("resources.companies.action.new")}
      defaultValues={{ sales_id: identity?.id }}
      transform={withWebsiteProtocol}
      open={open}
      onOpenChange={onOpenChange}
    >
      <CompanyInputs />
    </CreateSheet>
  );
};

/** Edit an organization from the phone, saved at once, not undoable (D-033) */
export const CompanyEditSheet = ({
  open,
  onOpenChange,
  companyId,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  companyId: Identifier;
}) => {
  const translate = useTranslate();
  return (
    <EditSheet
      resource="companies"
      id={companyId}
      title={translate("resources.companies.action.edit")}
      open={open}
      onOpenChange={onOpenChange}
      transform={withWebsiteProtocol}
      mutationMode="pessimistic"
    >
      <CompanyInputs />
    </EditSheet>
  );
};
